import { render, staticRenderFns } from "./ios-image-size-picker.vue?vue&type=template&id=0285b3d5"
import script from "./ios-image-size-picker.vue?vue&type=script&lang=ts"
export * from "./ios-image-size-picker.vue?vue&type=script&lang=ts"
import style0 from "./ios-image-size-picker.vue?vue&type=style&index=0&id=0285b3d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports